import { render } from "./SolutionDetailView.vue?vue&type=template&id=86655b06&scoped=true"
import script from "./SolutionDetailView.vue?vue&type=script&lang=js"
export * from "./SolutionDetailView.vue?vue&type=script&lang=js"

import "./SolutionDetailView.vue?vue&type=style&index=0&id=86655b06&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86655b06"]])

export default __exports__